import React from 'react';
import {createMuiTheme,ThemeProvider} from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#5dbcd2',
      //main: '#1b6a65',
      //main: '#6aa84f',
    },
    secondary: {
      main: '#424141',
      //main: '#666666',
    },
  },
  
  typography: {
    fontFamily: [
     /* 'Ubuntu Condensed',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',*/
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});


function MaterialThemeProvider(props) {
  return (
    <ThemeProvider theme={theme}>
        {props.children}
    </ThemeProvider>
  );
}

export default MaterialThemeProvider;
